module.exports = __webpack_public_path__ + "img/Tenure-Icon.8b113e7f.webp";